import { type Coord } from "./types";

export const setMousePositionFromCoord = (element: HTMLElement, coord: Coord) => {
  element.style.setProperty("--mouse-event-x", `${coord.x}px`);
  element.style.setProperty("--mouse-event-y", `${coord.y}px`);
};

export const waitForAnimationEnd = (element: HTMLElement) => {
  return new Promise((resolve) => {
    element.addEventListener("animationend", resolve, { once: true });
  });
};